export const countryNames = {
  en: {
    au: "Australia",
    ca: "Canada",
    ch: "Switzerland",
    de: "Germany",
    eu: "Europe",
    gb: "United Kingdom",
    global: "Global",
    nz: "New Zealand",
    us: "United States",
  },
  de: {
    au: "Australien",
    ca: "Kanada",
    ch: "Schweiz",
    de: "Deutschland",
    eu: "Europa",
    gb: "Vereinigtes Königreich",
    global: "Global",
    nz: "Neuseeland",
    us: "Vereinigte Staaten",
  },
} as const

/**
 * Look up a base-market slug's localized name in this catalog via a bound
 * translator, falling back to `fallback` (typically the English-only
 * `marketsData` label) for any slug missing a catalog entry. Generic over the
 * translator's own key type so it accepts any `getT` bound with `countryNames`
 * alongside other namespaces.
 */
export const localizedCountryName = <Key extends string>(
  t: (key: Key & `countryNames.${string}`) => string,
  baseSlug: string,
  fallback: string
): string => {
  const key = `countryNames.${baseSlug}` as Key & `countryNames.${string}`
  const localized = t(key)
  return localized === key ? fallback : localized
}
